import { PServed } from '@wui/im'

const autoAnswerMap = {} as { [number: string]: number }
const mediaMap = {} as { [number: string]: { audio: boolean, video: boolean } }
const resolveFnMap = new Map<PServed, () => void>()

export function useAutoAnswer () {
  const registerAutoAnswer = (
    pServedUser: PServed,
    audio = true,
    video = false,
    time = 3000,
  ) => {
    return new Promise<void>((resolve, reject) => {
      if (!autoAnswerMap[pServedUser]) {
        autoAnswerMap[pServedUser] = 0
        resolveFnMap.set(pServedUser, resolve)
      }
      autoAnswerMap[pServedUser] = autoAnswerMap[pServedUser] + 1
      mediaMap[pServedUser] = { video, audio }
      setTimeout(() => {
        autoAnswerMap[pServedUser] = Math.max((autoAnswerMap[pServedUser] ?? 0) - 1, 0)
        if (autoAnswerMap[pServedUser] === 0) {
          resolveFnMap.delete(pServedUser)
          reject()
        }
      }, time)

    })
  }

  const removeAutoAnswer = (pServedUser: string) => {
    delete autoAnswerMap[pServedUser]
    resolveFnMap.delete(pServedUser)
  }

  const checkAutoAnswer = (pServedUser: string) => {
    const mediaConstraint = mediaMap[pServedUser]
    if (resolveFnMap.has(pServedUser)) {
      resolveFnMap.get(pServedUser)?.()
      resolveFnMap.delete(pServedUser)
    }
    return (autoAnswerMap[pServedUser] ?? 0) > 0 ? mediaConstraint : false
  }

  const changeMediaConstraints = (pServed: string, audio: boolean, video: boolean) => {
    if (mediaMap[pServed]) {
      mediaMap[pServed] = {
        audio,
        video,
      }
    }
  }

  return {
    registerAutoAnswer,
    checkAutoAnswer,
    removeAutoAnswer,
    changeMediaConstraints,
  }
}
